(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fifi-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fifiCardHover) return;
    window.__fifiCardHover = true;

    // Pin the size panel to the bottom edge of the card image, whatever the card shape
    function place(event) {
      var card = event.target.closest && event.target.closest('[data-fifi-card]');
      if (!card) return;
      var hover = card.querySelector('[data-fifi-hover]');
      var media = card.querySelector('.fifi-card__media');
      if (!hover || !media) return;
      hover.style.top = (media.offsetTop + media.offsetHeight) + 'px';
      hover.setAttribute('data-ready', '');
    }

    document.addEventListener('pointerover', place, { passive: true });
    document.addEventListener('focusin', place);
  })();
  } catch(e) { console.error(e); }
})();

})();
